import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"

//Import sections
import Blacklist from "./BlacklistList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const BlacklistView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Blacklists | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Blacklists" breadcrumbItem="Manage Blacklists" />
          <Row>
            <Col lg="12">
              <Blacklist />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

BlacklistView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(BlacklistView)
